/*
 * Notice: This software is proprietary to Pocketbook, its affiliates, partners and/or
 * licensors. Unauthorized copying, distribution or use is strictly prohibited.
 * All rights reserved.
 */

!function () {
    "use strict";

    angular.module('webReader').service('HashService', constructor);

    function constructor($location) {
        var self = this;
        var hashParameters = {};
        var hash = location.hash;

        console.log(hash);

        self.create = function() {
            hash = hash.slice(2);
            !!hash.length && self.parseHash();
            location.hash = '';
        };

        self.parseHash = function () {
            var regExr = new RegExp("&path=(.+\.epub|pdf)", 'gi');
            var path = regExr.exec(hash);
            path = path ? path[1] : path
            // hash = hash.replace(regExr, "");
            hash.split('&').forEach(function (el, i) {
                el = el.split('=');
                hashParameters[el[0]] = decodeURIComponent(el[1]);
            });
            if (path)
                hashParameters.path = decodeURIComponent(path);
            console.log("hashParameters",hashParameters);
        };

        self.getHashParameters = function(){
            return hashParameters;
        }
    }
    constructor.$inject = ["$location"];
}();